type PracticeContactPhoneSource = {
  phone?: string
  user?: { phone?: string }
  phoneNumber?: string
  phone_number?: string
}

/**
 * Phone shown on Builder V2 public contact should follow `/portal/settings/personal`
 * (stored on the practitioner user). Section `settings.phoneNumber` is only a fallback
 * when the account has no phone — otherwise it can stay stale after account updates.
 */
export function builderV2PreferredPracticePhone(
  practice?: PracticeContactPhoneSource | null,
  sectionSettingsPhone?: string | null
): string {
  const fromAccount =
    practice?.phone ||
    practice?.user?.phone ||
    practice?.phoneNumber ||
    practice?.phone_number ||
    ""
  if (fromAccount) return fromAccount
  return sectionSettingsPhone != null ? String(sectionSettingsPhone) : ""
}
